const cutDownLengthAndRemoveTrailingHyphen = () => {
  const result = process.env.CI_COMMIT_REF_SLUG?.slice(0, 22)
  if (result) {
    let i = result.length
    while (i > 0 && result[i - 1] === '-') {
      i--
    }
    return result.slice(0, i)
  }
  return result
}

export const cutDownCommitSlug = cutDownLengthAndRemoveTrailingHyphen()
